import HorsesTableItem from './EntriesTableItem';

export default HorsesTableItem;
